<template>
<div>
    <div v-if="loading_page === true">
        <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
            <v-skeleton-loader type="article, actions"></v-skeleton-loader>
        </v-sheet>
    </div>
    <div v-if="loading_page === false">
        <div class="all_menu_content">
            <v-card class="list_menu_content" v-if="$store.state.userProfile.per_ordeer == 1">
                <router-link to="/contentorder" class="menu_card_content d-flex flex-column justify-center align-center">
                    <div class="img_menu_content">
                        <img src="@/assets/box.png">
                    </div>
                    <div class="title_menu_content">
                        คำสั่งซื้อ
                    </div>
                </router-link>
            </v-card>
            <v-card class="list_menu_content" v-if="$store.state.userProfile.per_customer == 1">
                <router-link to="/contentcustomer" class="menu_card_content d-flex flex-column justify-center align-center">
                    <div class="img_menu_content">
                        <img src="@/assets/rating.png">
                    </div>
                    <div class="title_menu_content">
                        ข้อมูลลูกค้า
                    </div>
                </router-link>
            </v-card>
            <v-card class="list_menu_content" v-if="$store.state.userProfile.per_setup_product == 1">
                <router-link to="/contentslide" class="menu_card_content d-flex flex-column justify-center align-center">
                    <div class="img_menu_content">
                        <img src="@/assets/picture.png">
                    </div>
                    <div class="title_menu_content">
                        จัดการรูปภาพหน้าเว็บไซต์
                    </div>
                </router-link>
            </v-card>
            <v-card class="list_menu_content" v-if="$store.state.userProfile.per_blog == 1">
                <router-link to="/contentblog" class="menu_card_content d-flex flex-column justify-center align-center">
                    <div class="img_menu_content">
                        <img src="@/assets/copywriting.png">
                    </div>
                    <div class="title_menu_content">
                        บทความ
                    </div>
                </router-link>
            </v-card>
            <v-card class="list_menu_content" v-if="$store.state.userProfile.per_setup_web == 1">
                <router-link to="/contentabout" class="menu_card_content d-flex flex-column justify-center align-center">
                    <div class="img_menu_content">
                        <img src="@/assets/settings.png">
                    </div>
                    <div class="title_menu_content">
                        ตั้งค่าเว็บไซต์
                    </div>
                </router-link>
            </v-card>
        </div>
    </div>
</div>
</template>

<script>
import {
    HTTP
} from "@/axios.js"
export default {
    name: 'content',
    inject: {
        theme: {
            default: {
                isDark: false
            },
        },
    },
    data() {
        return {
            loading_page: true
        }
    },
    methods: {
        async buffetList() {
            this.loading_page = true
            HTTP.get('/buffet/list', {
                    headers: {
                        "Authorization": `Bearer ${this.$store.state.token}`
                    }
                })
                .then((response) => {
                    if (response.data.successful === true) {
                        this.loading_page = false
                    }

                }).catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                })
        },
    },
    mounted() {
        this.buffetList()
    }
}
</script>

<style scoped>
.all_menu_content {
    display: grid;
    grid-template-columns: 50% 50%;
    grid-row-gap: 8px;
}

.list_menu_content {
    padding: 15px;
}

.list_menu_content:nth-child(odd) {
    margin-right: 4px;
}

.list_menu_content:nth-child(even) {
    margin-left: 4px;
}

.list_menu_content:hover {
    background: #28ab28 !important;
    transition: 0.1s !important;
}

.list_menu_content:hover>.menu_card_content {
    color: #fff !important;
}

.menu_card_content {
    text-decoration: none;
    color: rgba(0, 0, 0, 0.87) !important;
}

.img_menu_content {
    width: 100px;
}

.img_menu_content>img {
    max-width: 100%;
}

.title_menu_content {
    font-size: 20px;
}
</style>
